import { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

export const CompetitionBravoModal: FC<{competitionId: string, onClick: () => void, someNominations?: boolean, isShareModal?: boolean, isExam?: boolean}> = ({competitionId, isExam, isShareModal, someNominations, onClick}) => {

    const {t, i18n: {language}} = useTranslation()

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
            <Title>
                {isExam ? <span>Проект подан <br/> на участие в экзамене</span> :
                    <span>
                        {t('competitions_send_modal.project_submitted')} 
                        {language === 'ru' ? <br/> : ''} 
                        {language === 'ru' ? `на участие в конкурс${someNominations? 'ах' : "е"}` : ''}
                    </span>}
            </Title>
            <Description>
                {isExam ? 'Проект проверят преподаватели, после чего вы получите уведомление об оценке' : t('competitions_send_modal.main')}
            </Description>
            <FlexBox justify={'center'} offsetTop={40}>
                <SendProjectButton width={283} onClick={onClick}>
                    {isExam ? 'На страницу модуля' : isShareModal ? 'На главную' : t('competitions_send_modal.to_contest_button')}
                </SendProjectButton>
            </FlexBox>
        </FlexBox>
    </div>

};
import { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

export const CompetitionBravoModal: FC<{competitionId: string, onClick: () => void, someNominations?: boolean, isShareModal?: boolean, isExam?: boolean}> = ({competitionId, isExam, isShareModal, someNominations, onClick}) => {

    const {t, i18n: {language}} = useTranslation()

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
            <Title>
                {isExam ? <span>Проект подан <br/> на участие в экзамене</span> :
                    <span>
                        {t('competitions_send_modal.project_submitted')} 
                        {language === 'ru' ? <br/> : ''} 
                        {language === 'ru' ? `на участие в конкурс${someNominations? 'ах' : "е"}` : ''}
                    </span>}
            </Title>
            <Description>
                {isExam ? 'Проект проверят преподаватели, после чего вы получите уведомление об оценке' : t('competitions_send_modal.main')}
            </Description>
            <FlexBox justify={'center'} offsetTop={40}>
                <SendProjectButton width={283} onClick={onClick}>
                    {isExam ? 'На страницу модуля' : isShareModal ? 'На главную' : t('competitions_send_modal.to_contest_button')}
                </SendProjectButton>
            </FlexBox>
        </FlexBox>
    </div>

};
